import { jsx as a, jsxs as v, Fragment as Q } from "react/jsx-runtime";
import { ChipCloseIcon as X } from "./index.es815.js";
import { useIsTextOverflowing as Y, useOnClickOutside as Z } from "@placer-ui/hooks";
import V from "classnames";
import { noop as E } from "lodash/fp";
import { forwardRef as I, useRef as _, useState as D, useEffect as k, useCallback as x, useMemo as rr, cloneElement as or } from "react";
import r from "./index.es819.js";
import { ColorIndicator as er } from "./index.es32.js";
import { SmartTooltipWrapper as ar } from "./index.es525.js";
import { getDisabledAria as tr } from "./index.es530.js";
import { UtilityChevronIcon as nr } from "./index.es439.js";
import { BodyText as w } from "./index.es505.js";
import { mergeRefs as ir } from "./index.es551.js";
import { onKeyDownEnterAndSpace as sr } from "./index.es526.js";
const lr = "compare-bar-chip", Er = I(
  ({
    actionIcon: $,
    entityColor: m,
    lockedTooltip: S,
    categoryText: p,
    tagValue: i,
    Icon: g,
    colorIndicator: A,
    tooltip: B,
    isSelected: f,
    isCollection: y,
    isFloating: j,
    isSearchFilter: z,
    isDisabled: e,
    shouldDeselectOnOutsideClick: T = !1,
    disableSelectedIndicator: F,
    locked: o = !1,
    hasChevron: K = !1,
    hasClose: M = !1,
    testId: t = lr,
    onClick: d = E,
    actionOnClick: s = E,
    ...H
  }, U) => {
    const u = _(null), N = _(null), h = $ === "chevron" || K, R = $ === "close" || M, { textElmRef: L, isOverflowing: W } = Y(), [l, b] = D(!1);
    k(() => {
      b(!!f);
    }, [f]);
    const q = V(r["compare-bar-chip-root"], {
      [r["is-selected"]]: !F && !h && (l || f),
      [r["no-action-icon"]]: !R || o,
      [r["is-collection"]]: y,
      [r.floating]: j,
      [r["no-color-indicator"]]: !m,
      [r["search-filter"]]: z,
      [r.isDisabled]: e,
      [r["is-locked"]]: o
    }), c = f !== void 0 && s !== E, P = x(
      (n) => {
        o || (h ? (n.stopPropagation(), c ? s() : (s(), d(n), b((C) => !C))) : (s(), n.stopPropagation()));
      },
      [o, h, c, s, d]
    ), G = x(
      (n) => {
        e || o || (d(n), b((C) => !C));
      },
      [e, o, d]
    ), J = x(
      (n) => {
        N.current && N.current.contains(n.target) || u.current && u.current.contains(n.target) || T && !c && !o && b(!1);
      },
      [T, c, o]
    );
    Z(J, c || o ? null : u);
    const O = rr(
      () => y ? /* @__PURE__ */ a("span", { className: r.collection, "data-testid": `${t}-collection`, children: /* @__PURE__ */ a(
        w,
        {
          variant: "semi-bold",
          color: e ? "disabled" : "primary",
          "data-testid": `${t}-collection-text`,
          children: p
        }
      ) }) : /* @__PURE__ */ v(Q, { children: [
        m && /* @__PURE__ */ a("span", { className: r["color-indicator"], children: /* @__PURE__ */ a(
          er,
          {
            entityColor: m,
            disabled: e,
            testId: `${t}-color-indicator`,
            ...A
          }
        ) }),
        g && /* @__PURE__ */ a("span", { className: r.icon, "data-testid": `${t}-icon`, children: or(g, {
          outline: e ? "disabled" : "default-gray",
          color: e ? "outline" : "gray",
          size: 16
        }) }),
        /* @__PURE__ */ v("span", { className: r.labels, "data-testid": `${t}-labels`, children: [
          /* @__PURE__ */ a(
            w,
            {
              variant: "semi-bold",
              color: e ? "disabled" : "primary",
              "data-testid": `${t}-labels-categoryText`,
              children: p
            }
          ),
          /* @__PURE__ */ a(
            w,
            {
              ref: L,
              isEllipsis: !0,
              color: e ? "disabled" : "primary",
              "data-testid": `${t}-labels-tagValue`,
              variant: l ? "semi-bold" : "regular",
              children: i
            }
          )
        ] })
      ] }),
      [
        y,
        t,
        e,
        p,
        m,
        A,
        g,
        L,
        l,
        i
      ]
    );
    return /* @__PURE__ */ v("div", { style: {
      display: "flex",
      alignItems: "center",
      position: "relative"
    }, tabIndex: -1, className: r.root, children: [
      /* @__PURE__ */ a(
        ar,
        {
          tooltip: B,
          isLocked: o,
          lockedTooltip: S,
          itemLabel: i,
          isDisabled: e,
          isOverflowing: W,
          ref: ir(u, U),
          children: /* @__PURE__ */ v(
            "button",
            {
              className: q,
              "data-testid": t,
              onClick: G,
              "aria-pressed": l,
              "aria-label": o ? `Locked filter: ${p}${i ? ` ${i}` : ""}` : H["aria-label"],
              "data-locked": o,
              ...tr(!!e, !!B, "disabled"),
              ...H,
              children: [
                O,
                h && !o && /* @__PURE__ */ a("span", { role: "presentation", className: r.chevron, children: /* @__PURE__ */ a(
                  nr,
                  {
                    "data-testid": `${t}-action-icon-chevron`,
                    size: 16,
                    direction: l ? "up" : "down",
                    type: "normal"
                  }
                ) })
              ]
            }
          )
        }
      ),
      R && !o && /* @__PURE__ */ a(
        "button",
        {
          ref: N,
          className: r["action-icon"],
          "data-type": $,
          onClick: P,
          onKeyDown: (n) => sr(n, P),
          "data-testid": `${t}-action-icon`,
          "aria-label": R ? "Remove filter" : "Toggle options",
          disabled: e,
          children: /* @__PURE__ */ a(X, {})
        }
      )
    ] });
  }
);
export {
  lr as COMPARE_BAR_CHIP_DEFAULT_TESTID,
  Er as CompareBarChip
};
//# sourceMappingURL=index.es37.js.map
